<!-- Main Header Section - Stick to header component -->
<div class="main-header-container" [class.not-flex-based]="!flexBasedUi">
  <!-- Navigation Tabs -->
  <div class="navigation-tabs">
    <button *ngIf="isInEvent && userPrivileges.has('event_candidate.view')" class="nav-tab"
      [ngClass]="{'active': displayOverview}" (click)="showOverview()">
      <i class="pi pi-gauge" style="font-size: 16px;"></i>
      Overview
    </button>
    <button *ngIf="userPrivileges.has('event_candidate.view')" class="nav-tab" [ngClass]="{'active': displayCandidates}"
      (click)="showCandidates()">
      <img src="assets/icons-svg/Candidates Icon.svg" alt="Candidates" class="nav-icon">
      Candidates
    </button>
    <button class="nav-tab" [ngClass]="{'active': displayJobDetails}" (click)="showJobDetails()">
      <img src="assets/icons-svg/Event Details Icon.svg" alt="Event Details" class="nav-icon">
      {{ isInEvent ? 'Event' : 'Job'}} Details
    </button>
    <button *ngIf="userPrivileges.has('event_stage.view')" class="nav-tab" [ngClass]="{'active': displayWorkflow}"
      (click)="showWorkflow()">
      <img src="assets/icons-svg/Stages Icon.svg" alt="Stages" class="nav-icon">
      Stages
    </button>
    <button *ngIf="userPrivileges.has('event_interview.view')" class="nav-tab" [ngClass]="{'active': displayInterview}"
      (click)="showInterview()">
      <img src="assets/icons-svg/Interview Icon.svg" alt="Interview" class="nav-icon">
      Interview
    </button>
    <div class="stage-header-actions" *ngIf="displayWorkflow">
      <button *ngIf="userPrivileges.has('event_stage.create')" pButton type="button"
        class="p-button-raised p-button-text stage-action-btn" (click)="onAddStageClick()">
        Add Stage
      </button>
    </div>
  </div>

  <!-- Action Buttons -->
  <div class="header-actions" *ngIf="displayCandidates">
    <button class="copy-link-btn" *ngIf="userPrivileges.has('event_candidate.add') || userPrivileges.has('candidate.invite')" (click)="copyRegistrationLink()">
      <img src="assets/icons-svg/copy-link.svg" alt="Link" class="btn-icon">
      Registration Link
    </button>

    <button class="main-send-invite-btn" *ngIf="userPrivileges.has('event_candidate.add') || userPrivileges.has('candidate.invite')"
      (click)="showBulkUpload = true">
      Send Invite
    </button>

    <!-- Simple Add Candidate Button -->
    <button class="add-candidate-btn" *ngIf="userPrivileges.has('event_candidate.add') || userPrivileges.has('candidate.invite')" (click)="addCandidateForm()">
      Add Candidate
    </button>
  </div>
</div>

<!-- Filter Tabs Container - Stick to main header -->
<div class="filter-tabs-container" *ngIf="displayCandidates">
  <div class="filter-tabs">
    <div class="filter-tab" *ngIf="selectedCandidates.length === 0" [ngClass]="{'active': statusFilter === 'All'}"
      (click)="setStatusFilter('All')">
      All Candidates
      <span class="candidate-count">{{ totalLength || 0 }}</span>
    </div>

    <div class="selected-candidates-bar" *ngIf="selectedCandidates.length > 0">
      <span class="selected-count">{{ selectedCandidates.length }} selected</span>
      <button
        class="edit-details-btn"
        *ngIf="selectedCandidates.length === 1 && userPrivileges.has('event_candidate_edit_registration.view')"
        (click)="openEditCandidateDetails()"
        pTooltip="Edit registration details"
        tooltipPosition="top">
        Edit Details
      </button>
    </div>

    <!-- Search moved after All Candidates -->
    <div class="search-container-inline" *ngIf="selectedCandidates.length === 0">
      <em class="pi pi-search search-icon"></em>
      <input class="search-input-inline" type="text" [(ngModel)]="searchText" (input)="onSearchInputChange()" pInputText
        placeholder="Search Email" />
    </div>
  </div>

  <!-- Table Controls -->
  <div class="table-controls">
    <button pButton class="control-btn" pTooltip="Column Settings" tooltipPosition="top"
      (click)="onClickSettingsSidebar()">
      <img src="assets/icons-svg/column-setting.svg" alt="Settings" />
    </button>
    <button pButton class="control-btn" pTooltip="Filter" tooltipPosition="top"
      (click)="showSettingsSidebar = false; showDownloadSidebar = false; filterShow()">
      <img src="assets/icons-svg/filter.svg" alt="Filter" />
      <span *ngIf="candidateFilter.getFilterCount()" class="count-badge">
        {{candidateFilter.getFilterCount()}}
      </span>
    </button>
    <button pButton class="control-btn" *ngIf="userPrivileges.has('event_candidate.export')"
      (click)="showDownloadSidebar = true; showSettingsSidebar = false;" pTooltip="Download" tooltipPosition="top">
      <img src="assets/icons-svg/download.svg" alt="Download" />
    </button>
    <button pButton class="control-btn" (click)="refreshTable()" pTooltip="Refresh" tooltipPosition="top">
      <img src="assets/icons-svg/refresh.svg" alt="Refresh" />
    </button>
    <span class="table-menu">
      <p-select class="view-list-dropdown" [options]="pageLimits" [(ngModel)]="pageSize"
        (onChange)="getUsersByLimit()">
      </p-select>
      <button pButton (click)="prev()" [disabled]="isFirstPage() || loadingSpinner"
        class="p-button-secondary p-button-text simple-btn">
        <img src="assets/icons-svg/chevron-left.svg" alt="Previous" class="icon-svg">
      </button>
      <button pButton class="disabled p-button-secondary p-button-text simple-btn">{{ loadingSpinner ? '...' :
        pageNumber + ' of ' + totalPages }}</button>
      <button pButton (click)="next()" [disabled]="isLastPage() || loadingSpinner"
        class="p-button-secondary p-button-text simple-btn">
        <img src="assets/icons-svg/chevron-right.svg" alt="Next" class="icon-svg">
      </button>
    </span>
  </div>
</div>

<div class="" *ngIf="displayCandidates">
  <!-- Column Settings Sidebar -->
  <p-drawer styleClass="settingsSidebar" [transitionOptions]="'300ms'" [(visible)]="showSettingsSidebar" [modal]="false"
    position="right" [showCloseIcon]="false" [baseZIndex]="1000" (onShow)="updatedSelectedColFields()">

    <div class="settings-sidebar-header">
      <h3 class="settings-sidebar-title">Column Settings</h3>
    </div>
    <div class="settings-sidebar-center">
      <div class="settings-content-container">
        <!-- Search -->
        <div class="settings-search-container">
          <i class="pi pi-search"></i>
          <input type="text" class="settings-search-input" placeholder="Search" [(ngModel)]="columnSearchTerm"
            (ngModelChange)="searchColumns($event)" />
        </div>

        <div class="saved-columns-section" *ngIf="savedColumnSettings.length > 0">
          <div class="saved-columns-header">Saved Columns</div>
          <div class="saved-column-item" *ngFor="let column of savedColumnSettings"
            (click)="applySavedSettings(column.saved_columns)">
            <span class="saved-column-name">{{column.name}}</span>
            <i class="pi pi-trash saved-column-delete"
              (click)="$event.stopPropagation(); deleteSavedColumns(column.id)"></i>
          </div>
        </div>

        <!-- Column Selection -->
        <div class="settings-columns-section">
          <div class="settings-column-item" *ngFor="let col of _usersCol">
            <div class="column-item-left">
              <!-- <p-checkbox name="category" [value]="col" [(ngModel)]="checkedColumns" [inputId]="col.field">
              </p-checkbox> -->
               <p-checkbox 
                name="category"
                [value]="col.field"
                [ngModel]="checkedColumnsFields"
                (ngModelChange)="updateCheckedColumns($event)"
                [inputId]="col.field">
              </p-checkbox>
              <label [for]="col.field" class="settings-column-label">{{col.header}}</label>
            </div>
            <i class="fas fa-grip-vertical drag-handle"></i>
          </div>
        </div>

        <!-- Save Settings Section -->
        <div class="save-settings-section" *ngIf="!displaySaveColumnSettings">
          <div class="save-settings-toggle" (click)="showSaveColumnSettings()">
            Save Selected Columns
          </div>
        </div>

        <!-- Save Form -->
        <div class="save-settings-section" *ngIf="displaySaveColumnSettings">
          <form class="save-settings-form" [formGroup]="columnSettings" (ngSubmit)="saveColumnSettings()">
            <input type="text" class="save-settings-input" placeholder="Enter Column Set Name" formControlName="name">
            <button type="submit" pButton class="save-settings-btn" label="Save"></button>
            <button type="button" pButton class="p-button-text" (click)="clearColumnPreferenceName()">
              <i class="pi pi-times"></i>
            </button>
          </form>
        </div>
      </div>
    </div>

    <!-- Footer -->
    <div class="settings-actions">
      <button pButton class="settings-cancel-btn" label="Cancel" [outlined]="true"
        (click)="showSettingsSidebar = false;resetCheckedColumnsToDefault();clearColumnPreferenceName()">
      </button>
      <button pButton class="settings-apply-btn" label="Apply" (click)="applySelectedColumns()">
      </button>
    </div>
  </p-drawer>

  <!-- Download Sidebar -->
  <p-drawer styleClass="downloadSidebar candidateListDownload" [transitionOptions]="'300ms'"
    [(visible)]="showDownloadSidebar" [modal]="false" position="right" [showCloseIcon]="false" [baseZIndex]="1000">

    <!-- Header -->
    <div class="download-sidebar-header">
      <div class="header-top-row">
        <h3 class="download-sidebar-title">Download Candidate Data</h3>
        <div class="format-toggle">
          <div class="format-option">
            <div class="format-radio" [ngClass]="{'active': downloadAs === 'csv'}" (click)="downloadAs = 'csv'">
              <i class="pi pi-check" *ngIf="downloadAs === 'csv'"></i>
            </div>
            <span class="format-label" (click)="downloadAs = 'csv'">CSV</span>
          </div>
          <div class="format-option">
            <div class="format-radio" [ngClass]="{'active': downloadAs === 'excel'}" (click)="downloadAs = 'excel'">
              <i class="pi pi-check" *ngIf="downloadAs === 'excel'"></i>
            </div>
            <span class="format-label" (click)="downloadAs = 'excel'">EXCEL</span>
          </div>
        </div>
      </div>
    </div>

    <!-- Content Area -->
    <div class="download-sidebar-content">
      <div class="download-columns-section">
        <div class="download-column-item select-all-item">
          <p-checkbox [(ngModel)]="selectAllColumns" (onChange)="toggleSelectAll()" [binary]="true" inputId="selectAll">
          </p-checkbox>
          <label for="selectAll" class="download-column-label">Select All</label>
        </div>

        <!-- Regular Column Items -->
        <div class="download-column-item" *ngFor="let col of colsToDownload">
          <p-checkbox name="downloadColumns" [value]="col" [(ngModel)]="checkedColumns" [inputId]="col.field"
            (onChange)="onColumnCheckChange()">
          </p-checkbox>
          <label [for]="col.field" class="download-column-label">{{col.header}}</label>
        </div>
      </div>
    </div>

    <!-- Action Buttons -->
    <div class="download-actions">
      <div class="download-buttons-row">
        <button pButton class="cancel-btn" label="Cancel" [outlined]="true"
          (click)="showDownloadSidebar = false; resetCheckedColumnsToDefault()">
        </button>
        <button pButton class="download-btn" label="Download" [disabled]="checkedColumns.length === 0"
          (click)="(downloadAs === 'excel') ? exportCandidate('excel') : exportCandidate('csv')">
        </button>
      </div>
    </div>
  </p-drawer>

  <!-- Filter Sidebar -->
  <p-drawer *ngIf="candidateFilter.isOpen" styleClass="filter-sidebar-v2" [transitionOptions]="'300ms'"
    [modal]="false" [baseZIndex]="1000" ariaCloseLabel="Filter" [visible]="true" (visibleChange)="closeFilter($event)"
    position="right" [showCloseIcon]="false">

    <div class="filter-sidebar-v2-header">
      <h3 class="filter-sidebar-v2-title">Filter</h3>
    </div>

    <div class="filter-sidebar-v2-content">
      <p-accordion [multiple]="true" [collapseIcon]="'pi pi-minus'" [(value)]="activeTabIndex">

        <p-accordion-panel *ngIf="filterFieldVisibility['gender']" [value]="0">
          <p-accordion-header>Gender</p-accordion-header>
          <p-accordion-content>
            <div class="neo-input-wrapper">
              <p-select big nobg smbr panelStyleClass="statusFilter" appendTo="body" *ngIf="filterFieldTypes['gender'] === 'dropdown'"
                class="statusFilter" [style]="{width: '100%'}" [options]="genderList" id="filterOption"
                [ngModel]="candidateFilter.draft.gender" [showClear]="true" optionLabel="label" optionValue="value"
                (ngModelChange)="filterUpdate($event, 'gender')" placeholder="Select gender">
              </p-select>
            </div>
            <input *ngIf="filterFieldTypes['gender'] === 'input'" pInputText type="text"
              [ngModel]="candidateFilter.draft.gender" placeholder="Enter gender"
              (ngModelChange)="filterUpdate($event, 'gender')" [style]="{width: '100%'}">
          </p-accordion-content>
        </p-accordion-panel>

        <p-accordion-panel *ngIf="filterFieldVisibility['collegeName']" [value]="1">
          <p-accordion-header>College Name</p-accordion-header>
          <p-accordion-content>
            <div class="neo-input-wrapper">
              <p-multiselect big nobg smbr appendTo="body" *ngIf="filterFieldTypes['collegeName'] === 'dropdown'"
                class="multi-talent college-talent" (onPanelShow)="onInstitutionDropdownShow($event)"
                (onPanelHide)="onInstitutionDropdownHide($event)" [style]="{'width':'100%'}" [options]="collegeList"
                [ngModel]="candidateFilter.draft.collegeName" id="chips" display="chip" [maxSelectedLabels]="1"
                (onFilter)="filterInstitute($event)" #collegeName
                [panelStyle]="{
                    'min-width': collegeName.el.nativeElement.offsetWidth + 'px',
                    'max-width': collegeName.el.nativeElement.offsetWidth + 'px'
                }"
                [overlayOptions]="{styleClass: 'overflow-auto overflow-normal'}"
                [emptyFilterMessage]="loadingInstitutions ? 'Searching...' : 'No results found'" optionLabel="label"
                panelStyleClass="statusFilter" optionValue="value" (ngModelChange)="filterUpdate($event, 'collegeName')"
                placeholder="Select college name">
              </p-multiselect>
            </div>
            <input *ngIf="filterFieldTypes['collegeName'] === 'input'" pInputText type="text"
              [ngModel]="candidateFilter.draft.collegeName" placeholder="Enter college name"
              (ngModelChange)="filterUpdate($event, 'collegeName')" [style]="{width: '100%'}">
          </p-accordion-content>
        </p-accordion-panel>

        <p-accordion-panel *ngIf="filterFieldVisibility['degree']" [value]="7">
          <p-accordion-header>Degree</p-accordion-header>
          <p-accordion-content>
            <div class="neo-input-wrapper">
              <p-multiselect big nobg smbr appendTo="body" *ngIf="filterFieldTypes['degree'] === 'dropdown'"
                class="multi-talent" [style]="{'width':'100%'}" [options]="degreeList"
                [ngModel]="candidateFilter.draft.degree" id="chips" display="chip" [maxSelectedLabels]="1"
                [filter]="true" optionLabel="label" optionValue="value" panelStyleClass="statusFilter"
                [overlayOptions]="{styleClass: 'overflow-auto overflow-normal'}" #degreeFilter
                [panelStyle]="{
                    'min-width': degreeFilter.el.nativeElement.offsetWidth + 'px',
                    'max-width': degreeFilter.el.nativeElement.offsetWidth + 'px'
                }"
                (ngModelChange)="filterUpdate($event, 'degree')" placeholder="Select degree">
              </p-multiselect>
            </div>
            <input *ngIf="filterFieldTypes['degree'] === 'input'" pInputText type="text"
              [ngModel]="candidateFilter.draft.degree" placeholder="Enter degree"
              (ngModelChange)="filterUpdate($event, 'degree')" [style]="{width: '100%'}">
          </p-accordion-content>
        </p-accordion-panel>

        <p-accordion-panel *ngIf="filterFieldVisibility['specialization']" [value]="8">
          <p-accordion-header>Specialization</p-accordion-header>
          <p-accordion-content>
            <div class="neo-input-wrapper">
              <p-multiselect big nobg smbr appendTo="body" *ngIf="filterFieldTypes['specialization'] === 'dropdown'"
                class="multi-talent" [style]="{'width':'100%'}" [options]="specializationList"
                [ngModel]="candidateFilter.draft.specialization" id="chips" display="chip" [maxSelectedLabels]="1"
                [filter]="true" optionLabel="label" optionValue="value" panelStyleClass="statusFilter"
                [overlayOptions]="{styleClass: 'overflow-auto overflow-normal'}" #specializationFilter
                [panelStyle]="{
                    'min-width': specializationFilter.el.nativeElement.offsetWidth + 'px',
                    'max-width': specializationFilter.el.nativeElement.offsetWidth + 'px'
                }"
                (ngModelChange)="filterUpdate($event, 'specialization')" placeholder="Select specialization">
              </p-multiselect>
            </div>
            <input *ngIf="filterFieldTypes['specialization'] === 'input'" pInputText type="text"
              [ngModel]="candidateFilter.draft.specialization" placeholder="Enter specialization"
              (ngModelChange)="filterUpdate($event, 'specialization')" [style]="{width: '100%'}">
          </p-accordion-content>
        </p-accordion-panel>

        <p-accordion-panel *ngIf="filterFieldVisibility['jobRole']" [value]="2">
          <p-accordion-header>Job Role</p-accordion-header>
          <p-accordion-content>
            <div class="neo-input-wrapper">
              <p-multiselect big nobg smbr *ngIf="filterFieldTypes['jobRole'] === 'dropdown'" class="statusFilter"
                [style]="{width: '100%'}" [options]="jobRoles" [ngModel]="candidateFilter.draft.jobRole" optionLabel="label"
                optionValue="value" (ngModelChange)="filterUpdate($event, 'jobRole')" appendTo="body" #jobRole
                [panelStyle]="{
                    'min-width': jobRole.el.nativeElement.offsetWidth + 'px',
                    'max-width': jobRole.el.nativeElement.offsetWidth + 'px'
                }"
                panelStyleClass="statusFilter" placeholder="Select job roles">
              </p-multiselect>
              <input big nobg smbr *ngIf="filterFieldTypes['jobRole'] === 'input'" pInputText type="text"
                [ngModel]="candidateFilter.draft.jobRole" placeholder="Enter job role"
                (ngModelChange)="filterUpdate($event, 'jobRole')" [style]="{width: '100%'}">
            </div>
          </p-accordion-content>
        </p-accordion-panel>

        <p-accordion-panel *ngIf="filterFieldVisibility['stage']" [value]="3">
          <p-accordion-header>Stage</p-accordion-header>
          <p-accordion-content>
            <div class="neo-input-wrapper">
              <p-select big nobg smbr class="statusFilter" [style]="{width: '100%'}" [options]="stageList" id="filterOption"
                 [ngModel]="candidateFilter.draft.stage" [showClear]="true"
                panelStyleClass="statusFilter" optionLabel="label" appendTo="body" optionValue="value"
                (ngModelChange)="filterUpdate($event, 'stage')" placeholder="Select stage">
              </p-select>
            </div>
          </p-accordion-content>
        </p-accordion-panel>

        <p-accordion-panel *ngIf="filterFieldVisibility['status']" [value]="4">
          <p-accordion-header>Status</p-accordion-header>
          <p-accordion-content>
            <div class="neo-input-wrapper">
              <p-select big nobg smbr class="statusFilter" [style]="{width: '100%'}" [options]="statusList" id="filterOption"
                panelStyleClass="statusFilter"  [ngModel]="candidateFilter.draft.status"
                [showClear]="true" optionLabel="label" appendTo="body" optionValue="value"
                (ngModelChange)="filterUpdate($event, 'status')" placeholder="Select status">
              </p-select>
            </div>
          </p-accordion-content>
        </p-accordion-panel>

        <p-accordion-panel *ngIf="filterFieldVisibility['alignmentCategory']" [value]="5">
          <p-accordion-header>Agent Smith Insight</p-accordion-header>
          <p-accordion-content>
            <div class="neo-input-wrapper">
              <p-select big nobg smbr class="statusFilter" [style]="{width: '100%'}" [options]="alignmentCategoryList" id="filterOption"
                 [ngModel]="candidateFilter.draft.alignmentCategory" [showClear]="true"
                panelStyleClass="statusFilter" optionLabel="label" appendTo="body" optionValue="value"
                (ngModelChange)="filterUpdate($event, 'alignmentCategory')" placeholder="Select one category">
              </p-select>
            </div>
          </p-accordion-content>
        </p-accordion-panel>

        <p-accordion-panel *ngIf="filterFieldVisibility['candidate_sources']" [value]="6">
          <p-accordion-header>Source</p-accordion-header>
          <p-accordion-content>
            <div class="neo-input-wrapper">
              <p-multiselect big nobg smbr class="statusFilter" [style]="{width: '100%'}" [options]="candidateSourcesList" id="filterOption"
                [ngModel]="candidateFilter.draft.candidate_source_id" [showClear]="true" [maxSelectedLabels]="1"
                panelStyleClass="statusFilter" optionLabel="label" appendTo="body" optionValue="value"
                (ngModelChange)="filterUpdate($event, 'candidate_source_id')" placeholder="Select source">
              </p-multiselect>
            </div>
          </p-accordion-content>
        </p-accordion-panel>
      </p-accordion>
    </div>

    <div class="filter-actions">
      <div class="filter-buttons-row">
        <button pButton class="filter-cancel-btn" label="Cancel" [outlined]="true" (click)="cancelFilter()">
        </button>
        <button pButton class="filter-cancel-btn" label="Clear" [outlined]="true" type="button"
          (click)="clearSelectedFilters()">
        </button>
        <button pButton class="filter-apply-btn" label="Apply" [loading]="filterLoading"
          (click)="applySelectedFilter()">
        </button>
      </div>
    </div>
  </p-drawer>

  <!-- Main Table Container with fixed height and scrollable body -->
  <div class="main-table-container">
    <p-table #dt [columns]="_selectedColumns" [value]="loadingSpinner ? skeletonData : candidateList"
      [resizableColumns]="true" [rows]="pageSize" [loading]="false" [scrollable]="true" scrollDirection="both"
      responsiveLayout="scroll" dataKey="id" [selection]="selectedCandidates"
      (selectionChange)="onSelectedCandidateChange($event)" [exportFilename]="exportName" styleClass="modern-table">

      <ng-template pTemplate="header" let-columns>
        <tr class="modern-table-header"
          [ngClass]="{'moveTable': showSettingsSidebar || showDownloadSidebar || candidateFilter.isOpen}">
          <th scope="col"
              class="checkbox-column"
              pFrozenColumn>
            <div class="checkbox-container" *ngIf="candidateList.length">
              <p-tableHeaderCheckbox [disabled]="loadingSpinner"></p-tableHeaderCheckbox>
            </div>
          </th> 
          <th scope="col" class="candidate-name-column sortable-header" pFrozenColumn pResizableColumn
            pSortableColumn="name">
            CANDIDATE NAME
            <p-sortIcon class="sort-icon" field="name"></p-sortIcon>
          </th>
          <th *ngFor="let col of columns" scope="col" class="sortable-header" [style.width]="'11vw'" pResizableColumn
            [pSortableColumn]="col.sortable ? col.field : null">
            {{ col.header }}
            <p-sortIcon *ngIf="col.sortable" class="sort-icon" [field]="col.field"></p-sortIcon>
          </th>
        </tr>
      </ng-template>

      <ng-template pTemplate="body" let-candidate let-columns="columns">
        <tr class="modern-table-row"
          [ngClass]="{'moveTable': showSettingsSidebar || showDownloadSidebar || candidateFilter.isOpen, 'skeleton-row': loadingSpinner}"
          [style]="{cursor: loadingSpinner ? 'default' : 'pointer'}">
           <td class="checkbox-column" pFrozenColumn>
            <div class="checkbox-container">
              <ng-container *ngIf="!loadingSpinner; else skeletonCheckbox">
                <p-tableCheckbox [value]="candidate"></p-tableCheckbox>
              </ng-container>
              <ng-template #skeletonCheckbox>
                <div class="skeleton skeleton-checkbox"></div>
              </ng-template>
            </div>
          </td>
          <td (click)="!loadingSpinner && showUserDetails(candidate)" class="candidate-name-column" pFrozenColumn>
            <ng-container *ngIf="!loadingSpinner; else skeletonText">
              <div class="candidate-info">
                <div class="candidate-avatar" [style.background-color]="getAvatarColor(candidate.name)">
                  <!-- Show image if photo URL exists -->
                  <img *ngIf="hasValidPhoto(candidate)" [src]="candidate.photo" [alt]="candidate.name"
                    class="candidate-photo" (error)="onImageError($event, candidate)" (load)="onImageLoad($event)" />

                  <span class="candidate-initials" [style.display]="hasValidPhoto(candidate) ? 'none' : 'flex'">
                    {{ getInitials(candidate.name) }}
                  </span>
                </div>
                <div class="candidate-details">
                  <div class="candidate-name-row">
                    <span class="candidate-name">{{ candidate.name }}</span>
                    <div class="alignment-badge-small" [ngClass]="getAlignmentClass(candidate.alignment_category)"
                      (click)="$event.stopPropagation(); showUserDetails(candidate, 'insights')"
                      *ngIf="candidate.alignment_category">
                      {{ candidate.alignment_category }}
                    </div>
                  </div>
                  <span class="candidate-id"
                    (click)="$event.stopPropagation(); copyToClipboard(candidate.id, 'Candidate ID')"
                    (keydown.enter)="copyToClipboard(candidate.id, 'Candidate ID')"
                    (keydown.space)="copyToClipboard(candidate.id, 'Candidate ID')" title="Click to copy Candidate ID"
                    role="button" tabindex="0"
                    [attr.aria-label]="'Candidate ID: ' + getTruncatedId(candidate.id) + '. Click to copy to clipboard'">
                    {{ getTruncatedId(candidate.id) }}
                  </span>
                </div>
              </div>
            </ng-container>
            <ng-template #skeletonText>
              <div class="skeleton skeleton-text skeleton-text-long"></div>
            </ng-template>
          </td>

          <td *ngFor="let col of columns" (click)="!loadingSpinner && showUserDetails(candidate)"
            [style]="{width: '11vw'}">
            <ng-container *ngIf="!loadingSpinner; else skeletonCell">
              <span [ngSwitch]="true" class="box-data">
                <!-- Combined Stage Name with Stage Badge -->
                <span *ngSwitchCase="col.field === 'stage_name'">
                  <div class="stage-combined">
                    <span class="stage-name-text">{{ candidate.stage_name || '-' }}</span>
                    <div class="stage-badge">
                      {{ candidate._stageId || 0 }}/{{ numberOfStages || 0 }}
                    </div>
                  </div>
                </span>
                <span *ngSwitchCase="col.field === 'degree'"
                  [pTooltip]="candidate.degree" tooltipPosition="top" [tooltipOptions]="{showDelay: 500}">
                  {{ candidate.degree || '-' }}
                </span>
                <span *ngSwitchCase="col.field === 'degree_name'"
                  [pTooltip]="candidate.degree_name" tooltipPosition="top" [tooltipOptions]="{showDelay: 500}">
                  {{ candidate.degree_name || '-' }}
                </span>
                <span *ngSwitchCase="col.field === 'college_names'" class="college-names-text"
                  [pTooltip]="candidate[col.field]" tooltipPosition="top" [tooltipOptions]="{showDelay: 500}">
                  {{ candidate[col.field] ? candidate[col.field] : '-' }}
                </span>
                <span class="status-tag" *ngSwitchCase="col.field === 'status'"
                  [attr.data-status]="candidate[col.field] + '-tag'">
                  {{ candidate[col.field] }}
                </span>

                <!-- Date Fields -->
                <span *ngSwitchCase="col.field === 'created_at' || col.field === 'dob'">
                  {{ candidate[col.field] !== '-' ? (candidate[col.field] | date: "dd-MM-yyyy") : '-' }}
                </span>

                <span *ngSwitchCase="col.field === 'gender'">
                  {{candidate[col.field] ? (candidate[col.field] | titleCaseUnderscore) : '-'}}
                </span>

                <!-- Default Text -->
                <span [ngClass]="{'capitalize': col.isCapitalize}" *ngSwitchDefault>
                  {{candidate[col.field] ? candidate[col.field] : '-'}}
                </span>
              </span>
            </ng-container>
            <ng-template #skeletonCell>
              <div class="skeleton" [ngClass]="{
                'skeleton-badge': col.field === 'status' || col.field === 'stage',
                'skeleton-text': col.field !== 'status' && col.field !== 'stage'
              }"></div>
            </ng-template>
          </td>
        </tr>
      </ng-template>

      <ng-template pTemplate="emptymessage">
        <tr>
          <td [attr.colspan]="_selectedColumns.length + 2" class="empty-message-container">
            <div class="empty-state">
              <div class="empty-state-icon">
                <i class="pi pi-search"></i>
              </div>
              <h3 class="empty-state-title">No Candidates Found</h3>
              <p class="empty-state-description">
                Try adjusting filters or search terms.
              </p>
            </div>
          </td>
        </tr>
      </ng-template>
    </p-table>
  </div>

  <!-- Candidate Details Sidebar -->
  <div *ngIf="displayUserDetails">
    <p-drawer styleClass="candidateDetaile" [transitionOptions]="'0ms'" [(visible)]="displayUserDetails"
      styleClass="p-drawer-lg" position="right" [style]="{width: '650px'}">
      <app-candidate-info [disableActivity]="false" [selectedUser]="selectedUser"
        [numberOfStages]="numberOfStages"></app-candidate-info>
    </p-drawer>
  </div>

  <!-- Bulk Upload Sidebar -->
  <!-- Bulk Upload Dialog -->
   @if (false) {
  <p-dialog [(visible)]="showBulkUpload" [modal]="true" [closable]="false" [draggable]="false" [resizable]="false"
    [style]="{ width: '700px' }" [baseZIndex]="1100" (onHide)="sidebarClose()" class="neo-dialog">

    <div class="dialog-wrapper">
      <!-- Header -->
      <div class="dialog-header">
        <h2 class="dialog-title">Invite Candidate</h2>
        <button type="button" class="dialog-close-btn" (click)="sidebarClose()" aria-label="Close">
          <em class="pi pi-times"></em>
        </button>
      </div>

      <!-- Content -->
      <div class="dialog-content">
        <div class="content-wrapper">
          <form [formGroup]="bulkInviteForm" class="bulk-invite-form">
            <div class="bulkContainer">
              <p class="template-download-label">Download Sample Template</p>
              <div>
                <div class="template-download">
                  <div class="template-file_info">
                    <div class="file-icon-wrapper">
                      <p class="pi pi-file-excel template-file-icon"></p>
                    </div>
                    <div class="file-details">
                      <p class="file-name">Sample Bulk Invite Candidate.XLSX</p>
                      <p class="file-size">5.7 KB</p>
                    </div>
                  </div>
                  <button pButton type="button" label="Download" class="template-download-btn" (click)="sampleData()">
                  </button>
                </div>
              </div>

              <p class="template-upload-label">Upload File <span class="required">*</span></p>
              <div class="profilePhoto form-details">
                <div *ngIf="!cohortUploaded">
                  <div class="bulkUpload-dropzone" ngx-dropzone
                    [accept]="'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel'"
                    [multiple]="false" (change)="fileUpload($event)">
                    <ngx-dropzone-label *ngIf="!uploadingFile">
                      <div class="dropzone-label">
                        <em class="pi pi-cloud-upload upload-icon"></em>
                        <p class="upload-text">Drag & Drop your files here or <span class="link-text">Choose
                            Files</span></p>
                        <p class="format-text">Recommended: .XLSX</p>
                      </div>
                    </ngx-dropzone-label>
                    <div *ngIf="uploadingFile" class="loading-container center-loader">
                      <p-progressSpinner [style]="{height: '30px', width: '30px'}" strokeWidth="7"
                        animationDuration="0.5s">
                      </p-progressSpinner>
                    </div>
                  </div>
                </div>
                <div *ngIf="cohortUploaded">
                  <div class="uploaded-container">
                    <div class="bulk-main">
                      <div class="file-icon-uploaded">
                        <p class="pi pi-file template-file-icon-uploaded"></p>
                      </div>
                      <div class="cohort-file_info">
                        <p class="file-name">{{uploadedFileName}}</p>
                        <p class="file-size-uploaded">{{cohortFileSize}}</p>
                      </div>
                      <div class="cancel-btn" (click)="onRemoveExcel()">
                        <em class="pi pi-times cancel-icon"></em>
                      </div>
                    </div>
                  </div>
                </div>
                <div *ngIf="errorFileUrl" class="error-report-container">
                  <button pButton type="button" label="Download Error Report" icon="pi pi-download"
                    class="error-report-btn" (click)="downloadErrorReport()">
                  </button>
                </div>
              </div>
            </div>
          </form>
          <p class="upload-note">Maximum invitations: 5000 candidates.</p>
        </div>
      </div>

      <!-- Footer -->
      <div class="dialog-footer">
        <button pButton pRipple type="button" label="Send Invite" (click)="sendInvite()"
          [disabled]="!cohortUploaded || loadSingleInvite" [loading]="loadSingleInvite" class="send-invite-btn">
        </button>
      </div>
    </div>
  </p-dialog>
   }
</div>

@if (showBulkUpload) {
  <app-invite-candidate-v2 from="events" (close$)="showBulkUpload = false"></app-invite-candidate-v2>
}

<!-- Event Overview tab -->
<div *ngIf="displayOverview" class="overview-page">
  <app-event-overview [eventId]="eventId"></app-event-overview>
</div>

<!-- Other components remain the same -->
<div *ngIf="displayJobDetails" [ngClass]="{'jobDetails-page': displayJobDetails}">
  <app-event-details *ngIf="isInEvent"></app-event-details>
</div>

<div *ngIf="displayWorkflow" [ngClass]="{'workflow-page': displayWorkflow, 'flex-based': flexBasedUi}">
  <app-workflow (stagesEmitter)="stageDetails = $event;"></app-workflow>
</div>

<div *ngIf="displayInterview" [ngClass]="{'interview-page': displayInterview}">
  <app-interview-panel></app-interview-panel>
</div>

<p-dialog [(visible)]="showRegistrationLinkCopyDialog" [modal]="true" [closable]="false"
  [draggable]="false" [resizable]="false" [style]="{'max-width': '600px'}" styleClass="registration-header-dialog">
  <ng-template #header>
    <div class="registration-link-header-container">
      <div class="registration-link-header">
        <div class="registration-link-title">
          <i class="pi pi-link"></i> Generate Registration Link
        </div>
        <div class="registration-link-subtitle">
          Create a trackable registration link to share on different platforms.
        </div>
      </div>
    </div>
  </ng-template>

  <div class="registration-link-content">
    <div class="neo-input-wrapper">
      <label>Select Source</label>
      <p-select big nobg smbr [options]="candidateSources" [(ngModel)]="selectedCandidateSource" optionLabel="name"
        optionValue="id" appendTo="body" placeholder="Choose a registration source"></p-select>
    </div>

    <div class="registration-link-info">
      <div class="registration-link-icon">
          <i class="pi pi-cog"></i>
      </div>
      <div class="registration-info">
        Need a custom source? 
        <span class="registration-info-action" (click)="goToSources()">Go to Settings <i class="pi pi-external-link"></i> </span> 
        to create and manage your own sources.
      </div>
    </div>

    <div class="registration-link-footer">
      <button pButton [outlined]="true" severity="secondary" label="Cancel"
        (click)="showRegistrationLinkCopyDialog = false"></button>
      <button pButton label="Copy Link" icon="pi pi-link" [disabled]="!selectedCandidateSource"
        (click)="copyRegistrationLinkWithUtm()"></button>
    </div>
  </div>
</p-dialog>